module.exports = __webpack_public_path__ + "static/media/horseshoe-bay-bike.d6b32976.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/horseshoe-bay-bike.jpg
// module id = 289
// module chunks = 0